import type { Bid } from '@/data'
import api from '..'
import type { BidRungPayload } from './createBidRung'

export async function updateBidRung(
  id: number | string,
  payload: BidRungPayload,
): Promise<Bid> {
  const res = await api.put(`/bid-rungs/${id}`, payload)
  return res.data.data
}
